export const SHOPBY_ACCESSTOKEN = 'SHOPBY_SERVICE_SESSAT';
export const SHOPBY_REFRESHTOKEN = 'SHOPBY_SERVICE_SESSRT';
export const SESSION_INITIALIZE = 'SHOPBY_SERVICE_SESSION_INITIALIZE';
export const TOKEN_EXPIRE_TIME = 'TOKEN_EXPIRE_TIME';
export const AUTH_TOKEN_REFRESHED = 'AUTH_TOKEN_REFRESHED';

export const LEFT_MENU_FLG = 'LEFT_MENU_OPEN';
export const I18N_LOCALE = 'locale';
